export default function registerTableCustomizer(Alpine) {
  Alpine.data("tableCustomizer", (config) => ({
    tableName: config.tableName,
    columns: config.columns,
    density: config.density ?? 1,
    saveUrl: config.saveUrl,
    open: false,

    get densityClasses() {
      switch (this.density) {
        case 0:
          return {
            table: "text-xs",
            header: "text-xs",
            headerCell: "px-2 py-1.5",
            cell: "px-2 py-1.5"
          };
        case 2:
          return {
            table: "text-base",
            header: "text-xs",
            headerCell: "px-6 py-4",
            cell: "px-6 py-4"
          };
        default:
          return {
            table: "text-sm",
            header: "text-xs",
            headerCell: "px-4 py-3",
            cell: "px-4 py-3"
          };
      }
    },

    isVisible(key) {
      const col = this.columns.find((c) => c.key === key);
      return col ? col.visible : true;
    },

    visibleCount() {
      return this.columns.filter((c) => c.visible).length;
    },

    toggleColumn(key) {
      const col = this.columns.find((c) => c.key === key);
      if (!col) return;

      // Prevent hiding the last visible column
      if (col.visible && this.visibleCount() <= 1) return;

      col.visible = !col.visible;
      this.save();
    },

    increaseDensity() {
      if (this.density < 2) {
        this.density++;
        this.save();
      }
    },

    decreaseDensity() {
      if (this.density > 0) {
        this.density--;
        this.save();
      }
    },

    save() {
      const visibleColumns = this.columns.filter((c) => c.visible).map((c) => c.key);

      const csrfToken = document.querySelector('meta[name="csrf-token"]')?.getAttribute("content");

      fetch(this.saveUrl, {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": csrfToken,
          Accept: "application/json"
        },
        body: JSON.stringify({
          table_name: this.tableName,
          visible_columns: visibleColumns,
          density: this.density
        })
      }).catch((err) => console.warn("Table preference save failed:", err));
    }
  }));
}
